/**
 * Client theming that is read in more than one place.
 *
 * config["colors"]["btn"] has always set the fill of every primary button, while
 * the lettering on it was hardcoded white -- in a stylesheet rule for some
 * screens and in an inline style for others. A pale fill leaves white lettering
 * unreadable (one live config ships #A3E6E9), so the foreground is configurable
 * too.
 */

/** What every button used before this was configurable. */
export const BTN_TEXT_FALLBACK = "#ffffff";

/**
 * The configured button text colour, or white.
 *
 * Read from colors.btnText, or colors["btn-text"] -- the colours block mixes
 * camelCase and kebab-case keys already (btn, secoundaryBtn, incomplete-block),
 * so both spellings are accepted rather than making the client guess.
 */
export const btnTextColor = (config) => {
  const colors = (config && config["colors"]) || {};
  return colors["btnText"] || colors["btn-text"] || BTN_TEXT_FALLBACK;
};

/**
 * Publish it as a custom property on <html>.
 *
 * Buttons live in stylesheet rules, in inline styles, and inside overlays that
 * render outside the app tree; one property on the document element reaches all
 * of them through var(--btn-text, #fff), which is also why every reader states
 * white as the var fallback: before a config arrives, and for any client that
 * sets no text colour, nothing changes.
 */
export const applyBtnTextColor = (config) => {
  try {
    document.documentElement.style.setProperty(
      "--btn-text",
      btnTextColor(config)
    );
    return true;
  } catch (e) {
    // No DOM to write to: the var() fallbacks keep every button white.
    return false;
  }
};
